import React, { type ComponentProps } from 'react';
import { BaseIcon } from '@is24at/react-ui-core/Icons';

export const IRLogo = (props: ComponentProps<typeof BaseIcon>) => (
  <BaseIcon {...props} viewBox="0 0 112 152">
    <defs>
      <path id="a" d="M0 .026h111.507v151.973H0z" />
      <path id="c" d="M0 .027h25.617v25.504H0z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g>
        <mask id="b" fill="#fff" />
        <path
          d="M12.437.025C5.4.003.034 5.231 0 12.143c-.033 6.802 5.434 12.39 12.199 12.468 7.254.084 12.43-5.101 12.412-12.434C24.594 4.938 19.696.05 12.437.025zM1.08 108.452h22.342V36.578c-6.302 0-12.316.18-18.314-.072-3.354-.14-4.304.932-4.28 4.295.143 21.25.07 42.502.08 63.754 0 1.187.102 2.375.172 3.897zm34.489.612c4.222 0 8.105.245 11.94-.075 3.307-.276 5.114 1.141 6.82 3.756 7.79 11.938 15.839 23.706 23.563 35.686 1.773 2.75 3.71 3.648 6.852 3.563 7.784-.208 15.576-.057 23.365-.083.973-.003 1.946-.204 3.397-.367l-30.75-44.05c2.535-.965 4.425-1.621 6.265-2.396 18.638-7.843 27.049-27.284 19.36-46.007-6.116-14.89-18.199-21.895-33.776-22.624-11.524-.54-23.092-.135-34.641-.126-.753.001-1.506.23-2.246.349v22.945c10.608 0 20.934-.074 31.258.021 8.9.083 15.186 6.004 15.051 13.95-.131 7.744-6.503 13.4-15.146 13.412-8.863.013-17.726-.013-26.59.015-1.543.004-3.087.189-4.722.296v21.735z"
          fill="#FFF"
          mask="url(#b)"
        />
      </g>
      <path
        d="M37 108.624V86.666c1.615-.108 3.14-.294 4.664-.3 8.754-.027 17.508 0 26.262-.014 8.536-.012 14.83-5.726 14.96-13.55.132-8.027-6.075-14.008-14.867-14.091-10.196-.097-20.395-.023-30.872-.023v-23.18c.732-.12 1.475-.35 2.218-.351 11.407-.01 22.832-.42 34.215.126 15.384.736 27.318 7.812 33.358 22.856 7.594 18.915-.712 38.555-19.12 46.479-1.818.783-3.684 1.445-6.188 2.421l30.37 44.5c-1.432.165-2.394.367-3.355.37-7.693.028-15.389-.125-23.076.086-3.103.085-5.016-.822-6.768-3.6-7.629-12.103-15.579-23.993-23.273-36.053-1.685-2.641-3.469-4.073-6.735-3.794-3.788.324-7.623.076-11.793.076M.258 107c-.071-1.523-.175-2.712-.176-3.9C.072 81.838.147 60.573 0 39.31c-.023-3.366.944-4.438 4.358-4.298 6.105.252 12.227.071 18.642.071V107H.258z"
        fill="#676767"
      />
      <g>
        <mask id="d" fill="#fff" />
        <path
          d="M12.945.026C20.501.052 25.6 5.123 25.617 12.631c.02 7.608-5.368 12.986-12.92 12.899C5.658 25.449-.034 19.652 0 12.596.035 5.426 5.622.003 12.945.026"
          fill="#676767"
          mask="url(#d)"
        />
      </g>
    </g>
  </BaseIcon>
);
